module.exports = __webpack_public_path__ + "img/emilia-massa.b458f10d.jpg";